<template>
  <div>

    <div class="row">
      <div class="col-md-6">
        <h5 class="mt-2">{{ meta.totalCount }} usuários cadastrados no total</h5>
      </div>
      <div class="col-md-6 text-right">
        <button @click="find(true)" class="btn btn-primary ml-4"><RefreshCcwIcon/></button>
        <router-link tag="button" to="definitions?tab=users" class="btn btn-primary btn-xl ml-2">Ver todos</router-link>
      </div>
    </div>

    <table class="table table-borderless table-border table-align">
      <thead>
        <tr>
          <th>Nome</th>
          <th>Email</th>
          <th>Tipo de perfil</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in users" :key="user.id">
          <td><strong>{{ user.name }}</strong></td>
          <td><strong>{{ user.email }}</strong></td>
          <td><strong>{{ role(user) | t }}</strong></td>
        </tr>
      </tbody>
    </table>

  </div>

</template>

<script>
  import EntityProxy from '@/models/EntityProxy'
  import GetAccount from '@/mixins/GetAccount.vue'
  import ModelMapper from '@/mixins/ModelMapper'
  import { RefreshCcwIcon } from 'vue-feather-icons'

  export default {
    components: { RefreshCcwIcon },
    computed: {
      users() {
        return this.getModels || []
      }
    },
    created() {
      this.addOrderBy('created_at')
      this.includes.push('account_user')
      this.find()
    },
    data() {
      return {
        keyModel: 'dashboardUser',
        nameModel: 'User'
      }
    },
    methods: {
      find(force) {
        const key = this.$name()

        const data = this.$ls.get(key)
        if (!force && data) {
          this.setModels(EntityProxy.build(data.users))
          this.setMeta(EntityProxy.build(data.meta))
          return
        }

        this.asyncTemplateSelect({
          after: ({ models, meta }) => this.$ls.set(key, { meta: meta, users: models }, { minutes: 10 })
        })
      },
      role(user) {
        return (user.accountUser || {}).role
      }
    },
    mixins: [ModelMapper, GetAccount],
    name: 'DashboardUser'
  }
</script>

<style scoped>

</style>
